module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0062.jpg?v=6c305585";